import { apiClient } from "../apiClient";
import {
    TResponseListWrapper,
    TResponseItemWrapper,
} from "../../common/types/common";

import {
    TQuoteDetails,
    TQuote,
    TQuoteLineItems,
} from "../../common/types/quote";

export const addTestGeometry = async (geometry) => {
    return apiClient.post(`/Quote/TestGeometry`, geometry);
};

export const getAllQuotes = async () => {
    return apiClient.get(`/Quote/GetAllQuotes`);
};

export const getQuoteList = async ({ pagination: { pageSize, pageIndex }, sorting: { sortBy, isDescending}, filtering: { searchTerm } }): Promise<TResponseListWrapper<TQuote>> => {
    let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}`: '';
    if (sortBy && isDescending) {
        sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
    }

    const search = searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : '';

    return apiClient.get(`/Quote/GetQuotes?pageSize=${encodeURIComponent(pageSize)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}`);
};

export const getQuoteListForUser = async ({ userId, pagination: { pageSize, pageIndex }, sorting: { sortBy, isDescending}, filtering: { searchTerm } }): Promise<TResponseListWrapper<TQuote>> => {
    let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}`: '';
    if (sortBy && isDescending) {
        sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
    }

    const search = searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : '';

    return apiClient.get(`/Quote/GetQuotesForUser?userId=${encodeURIComponent(userId)}&pageSize=${encodeURIComponent(pageSize)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}`);
};

export const getQuote = async (quoteId): Promise<TResponseItemWrapper<TQuoteDetails>> => {
    return apiClient.get(`/Quote/GetQuote?quoteId=${encodeURIComponent(quoteId)}`);
};

export const getQuoteLineItems = async (quoteId): Promise<TResponseItemWrapper<TQuoteLineItems>> => {
    return apiClient.get(`/Quote/GetLineItems?quoteId=${encodeURIComponent(quoteId)}`);
};

export const getJobFromQuote = async (quoteId) => {
    return apiClient.get(`/Quote/ConvertToJob?quoteId=${encodeURIComponent(quoteId)}`);
};

export const createQuote = async (quote) => {
    return apiClient.post(`/Quote/CreateQuote`, quote);
};

export const addQuoteDetails = async (quote) => {
    return apiClient.post(`/Quote/AddQuoteDetails`, quote);
};

export const updateQuote = async (quote) => {
    return apiClient.post(`/Quote/UpdateQuote`, quote);
};

export const updateQuoteStatus = async (quote) => {
    return apiClient.post(`/Quote/UpdateStatus`, quote);
};

export const deleteQuote = async (quoteId) => {
    return apiClient.delete(`/Quote/DeleteQuote?quoteId=${encodeURIComponent(quoteId)}`);
};

export const replaceLineItemCategoryList = async (payload): Promise<any> => {
    return apiClient.postText(`/Quote/ReplaceLineItems`, payload);
};
